<template>
    <div>
        <div class="flex badge badge-pill badge-primary capitalize p-2">
            <i class="bi bi-house-lock" v-tooltip="`Akun ini memiliki akses fitur Wholesale Order`"></i>
        </div>
    </div>
</template>

<script>
export default {
	name: 'PrivateOrderFeature',
	props: {
		item: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {};
	},
};
</script>
